import { STATIC_REWRITE_PATHS, StaticRewritePathKeyType } from 'config/staticRewritePaths';

export const getIsStaticUrlAllowed = (path: string, domainUrl: string): boolean => {
    const pathSegments = path.split('/');

    for (const key in STATIC_REWRITE_PATHS[domainUrl]) {
        const rewriteKey = STATIC_REWRITE_PATHS[domainUrl][key as StaticRewritePathKeyType];

        if (typeof rewriteKey !== 'string') {
            continue;
        }

        const staticUrlSegments = rewriteKey.split('/');
        if (
            pathSegments.every((pathSegment, index) => {
                return staticUrlSegments[index] === pathSegment || staticUrlSegments[index]?.charAt(0) === ':';
            })
        ) {
            return true;
        }
    }

    return false;
};
